import SiafLiteApiRepository from "../../external/siafLiteApi";

class EnderecosEstoqueService {
  constructor() {
    this.urlBase = "/estoque/enderecos-estoque";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  findOrCreateEnderecos(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/find-create-enderecos`).patch(body);
  }
}

export default EnderecosEstoqueService;
